/**
 * @generated SignedSource<<78283326f7ebc0224f0cb799f4ae00b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorProjectWrapper_viewer$data = {
  readonly tradeInteriorProjectQuery: {
    readonly project: {
      readonly name: string | null;
      readonly url: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"InteriorProjectContent_searchResult" | "ProjectBreadcrumbs_searchResult" | "ProjectModalQueryRenderer_searchResult">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorProjectContent_viewer">;
  readonly " $fragmentType": "InteriorProjectWrapper_viewer";
};
export type InteriorProjectWrapper_viewer$key = {
  readonly " $data"?: InteriorProjectWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorProjectWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "loadPreview"
    },
    {
      "kind": "RootArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorProjectWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "loadPreview",
          "variableName": "loadPreview"
        },
        {
          "kind": "Variable",
          "name": "projectId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "TradeInteriorProjectQueryOutput",
      "kind": "LinkedField",
      "name": "tradeInteriorProjectQuery",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "designProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorProjectContent_searchResult"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectBreadcrumbs_searchResult"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectModalQueryRenderer_searchResult"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InteriorProjectContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2386e84a0f12ee3cf91329aca7af3ba2";

export default node;
